(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const toggle = document.querySelector('[data-mobile-nav-toggle]');
    const nav = document.getElementById('mobile-nav');
    if (toggle && nav) {
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (expanded) {
          nav.setAttribute('hidden', '');
        } else {
          nav.removeAttribute('hidden');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ingredients');

    // Sync every card body in a section to the tallest one - keeps the image
    // area on top of each card identical regardless of description length.
    const equalizeBodies = (section) => {
      const bodies = section.querySelectorAll('.ingredient-card__body');
      if (!bodies.length) return;
      bodies.forEach((b) => {
        b.style.height = '';
      });
      requestAnimationFrame(() => {
        let max = 0;
        bodies.forEach((b) => {
          max = Math.max(max, b.offsetHeight);
        });
        bodies.forEach((b) => {
          b.style.height = max + 'px';
        });
      });
    };

    sections.forEach((section) => {
      equalizeBodies(section);

      const viewport = section.querySelector('[data-ingredients-viewport]');
      if (!viewport) return;

      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let dragged = false;

      const onDown = (e) => {
        if (e.pointerType === 'touch') return;
        isDown = true;
        dragged = false;
        startX = e.clientX;
        startScroll = viewport.scrollLeft;
        viewport.classList.add('is-grabbing');
        try {
          viewport.setPointerCapture(e.pointerId);
        } catch (_) {}
      };

      const onMove = (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 4) dragged = true;
        viewport.scrollLeft = startScroll - dx;
      };

      const onUp = (e) => {
        if (!isDown) return;
        isDown = false;
        viewport.classList.remove('is-grabbing');
        try {
          viewport.releasePointerCapture(e.pointerId);
        } catch (_) {}
      };

      viewport.addEventListener('pointerdown', onDown);
      viewport.addEventListener('pointermove', onMove);
      viewport.addEventListener('pointerup', onUp);
      viewport.addEventListener('pointercancel', onUp);
      viewport.addEventListener('pointerleave', onUp);

      // Suppress click on cards immediately after a drag
      viewport.addEventListener(
        'click',
        (e) => {
          if (dragged) {
            e.preventDefault();
            e.stopPropagation();
            dragged = false;
          }
        },
        true
      );

      // Prevent native image drag from interrupting the gesture
      viewport.addEventListener('dragstart', (e) => e.preventDefault());
    });

    // Re-equalize on resize (text wraps differently) and after fonts load
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        sections.forEach(equalizeBodies);
      }, 150);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => sections.forEach(equalizeBodies));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-logos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-press-logos]');

    sections.forEach(function (section) {
      const viewport = section.querySelector('[data-press-logos-viewport]');
      const track = section.querySelector('[data-press-logos-track]');
      const row = section.querySelector('[data-press-logos-row]');
      if (!viewport || !track || !row) return;

      const mq = window.matchMedia('(max-width: 1100px)');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      let clone = null;

      function syncClone() {
        const wantClone = mq.matches && !reduce.matches;
        if (wantClone && !clone) {
          clone = row.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-press-logos-row');
          track.appendChild(clone);
        } else if (!wantClone && clone) {
          clone.remove();
          clone = null;
        }
      }

      syncClone();
      mq.addEventListener('change', syncClone);
      reduce.addEventListener('change', syncClone);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy-box-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // VSL product notes (Dan, 2026-10-16; docs/First-Visit Order Tracking — Plan.md in the project folder).
    // The VSL pages' own buttons link here with utm_content=vsl: remember that for this tab, so an add from this
    // tab counts as bought through the video page (_vsl_order "true"). A new ad click opens a new tab or in-app
    // view, which starts without the flag.
    // The VSL buttons also carry the first view as fv= (2026-10-19: Facebook's iPhone browser lost the cookie on
    // the way here for #1255 and #1257); kept for this tab, used only when the cookie is gone.
    try {
      var q = new URLSearchParams(location.search);
      if (q.get('utm_content') === 'vsl') sessionStorage.setItem('gr_vsl_cta', '1');
      if (/^[a-z0-9-]+\|[^|]+$/.test(q.get('fv') || '')) sessionStorage.setItem('gr_fv', q.get('fv'));
    } catch (e) {}
    // The split script's first-view cookie (gr_first = "<page handle>|<ISO time or before>") goes on the product
    // line as line item properties; without the cookie, the fv= value from the VSL button. Neither, no notes.
    // Keep in sync with vslNotes() in the VSL source (vsl-local/fragments/order-boxes/end.html), which always
    // sends _vsl_order "true".
    function vslNotes() {
      try {
        var m = document.cookie.match(/(?:^|;\s*)gr_first=([^;]*)/);
        var raw = m ? decodeURIComponent(m[1]) : null;
        if (!raw) {
          try {
            raw = sessionStorage.getItem('gr_fv') || new URLSearchParams(location.search).get('fv');
          } catch (e) {}
        }
        if (!raw) return null;
        var v = raw.split('|');
        if (!/^[a-z0-9-]+$/.test(v[0]) || !v[1]) return null;
        var cta = false;
        try {
          cta = sessionStorage.getItem('gr_vsl_cta') === '1';
        } catch (e) {}
        return { _vsl_page: v[0], _vsl_first_view: v[1], _vsl_order: cta ? 'true' : 'false' };
      } catch (e) {
        return null;
      }
    }

    document.querySelectorAll('[data-pbb2-hero]').forEach(function (root) {
      var cta = root.querySelector('[data-pbb2-cta]');
      var ctaErr = root.querySelector('[data-pbb2-cta-error]');
      var cardsWrap = root.querySelector('[data-pbb2-cards]');
      var cards = root.querySelectorAll('[data-pbb2-card]');

      function selected() {
        return root.querySelector('[data-pbb2-cards] input:checked');
      }

      // Radio-accordion: selected card expands, the other collapses (~250ms).
      function syncCards() {
        cards.forEach(function (c) {
          var input = c.querySelector('input');
          c.classList.toggle('is-selected', !!(input && input.checked));
        });
        if (ctaErr) ctaErr.hidden = true;
        if (cta) cta.disabled = false;
      }
      if (cardsWrap) {
        cardsWrap.addEventListener('change', function (e) {
          if (e.target && e.target.name === 'pbb2-plan') syncCards();
        });
      }
      syncCards(); // browsers may restore form state on reload — keep classes in step

      // Gallery — thumbnails + nav swap the main image with a slide transition.
      var thumbs = root.querySelector('[data-thumbs]');
      var mainImg = root.querySelector('[data-main] img');
      var mainWrap = root.querySelector('[data-main]');
      var animating = false;
      var DUR = 600;
      var EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
      var cache = Object.create(null);

      function preload(src) {
        if (!src) return Promise.resolve();
        if (cache[src]) return cache[src];
        cache[src] = new Promise(function (res) {
          var i = new Image();
          i.onload = i.onerror = res;
          i.src = src;
        });
        return cache[src];
      }

      // Proactively preload every gallery image when idle, so slides are instant.
      function preloadAll() {
        if (!thumbs) return;
        thumbs.querySelectorAll('button[data-full]').forEach(function (b) {
          preload(b.getAttribute('data-full'));
        });
      }
      if ('requestIdleCallback' in window) {
        requestIdleCallback(preloadAll, { timeout: 2000 });
      } else {
        setTimeout(preloadAll, 1500);
      }

      function slide(newSrc, dir) {
        if (!mainImg || !mainWrap || animating) return;
        animating = true;
        preload(newSrc).then(function () {
          var old = mainImg.cloneNode(true);
          old.removeAttribute('data-main');
          old.style.zIndex = '2';
          mainWrap.insertBefore(old, mainImg.nextSibling);
          var outTo = dir === 'prev' ? '100%' : '-100%';
          var inFrom = dir === 'prev' ? '-100%' : '100%';
          mainImg.src = newSrc;
          mainImg.removeAttribute('srcset');
          var a1 = old.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + outTo + ')' }], {
            duration: DUR,
            easing: EASE,
            fill: 'forwards',
          });
          var a2 = mainImg.animate([{ transform: 'translateX(' + inFrom + ')' }, { transform: 'translateX(0)' }], {
            duration: DUR,
            easing: EASE,
          });
          var done = 0;
          function fin() {
            done++;
            if (done >= 2) {
              old.remove();
              animating = false;
            }
          }
          a1.onfinish = a1.oncancel = fin;
          a2.onfinish = a2.oncancel = fin;
        });
      }

      function activeIndex(btns) {
        var i = btns.findIndex(function (b) {
          return b.classList.contains('is-active');
        });
        return i < 0 ? 0 : i;
      }

      function activateThumb(btn, dir) {
        if (!btn || !thumbs) return;
        // Ignore input while a slide is mid-transition so the active thumb
        // can't run ahead of the main image (fast prev/next double-clicks).
        if (animating) return;
        var btns = Array.prototype.slice.call(thumbs.querySelectorAll('button'));
        var prevIdx = activeIndex(btns);
        var nextIdx = btns.indexOf(btn);
        if (nextIdx === prevIdx) return;
        btns.forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        // Mobile progress dots mirror the active thumb index
        var dots = root.querySelectorAll('[data-dots] .pbb2-dot');
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === nextIdx);
        });
        // Keep the active thumb in view if the strip ever scrolls.
        var li = btn.parentElement;
        if (li && thumbs) {
          var tr = thumbs.getBoundingClientRect();
          var lr = li.getBoundingClientRect();
          if (lr.left < tr.left || lr.right > tr.right) {
            thumbs.scrollTo({
              left: thumbs.scrollLeft + (lr.left - tr.left) - (tr.width - lr.width) / 2,
              behavior: 'smooth',
            });
          }
        }
        var img = btn.querySelector('img');
        var nextSrc = btn.getAttribute('data-full') || (img && img.src);
        if (!nextSrc) return;
        slide(nextSrc, dir || (nextIdx > prevIdx ? 'next' : 'prev'));
      }

      if (thumbs) {
        thumbs.addEventListener('click', function (e) {
          var btn = e.target.closest('button[data-thumb]');
          if (btn) activateThumb(btn);
        });
      }

      // Tapping a dot jumps to that slide (direction inferred by activateThumb)
      var dotsWrap = root.querySelector('[data-dots]');
      if (dotsWrap && thumbs) {
        dotsWrap.addEventListener('click', function (e) {
          var d = e.target.closest('.pbb2-dot');
          if (!d) return;
          var i = Array.prototype.indexOf.call(dotsWrap.children, d);
          var btns = thumbs.querySelectorAll('button');
          if (btns[i]) activateThumb(btns[i]);
        });
      }

      function advance(dir) {
        if (!thumbs) return;
        var btns = Array.prototype.slice.call(thumbs.querySelectorAll('button'));
        if (!btns.length) return;
        var idx = activeIndex(btns);
        var step = dir === 'next' ? 1 : -1;
        activateThumb(btns[(idx + step + btns.length) % btns.length], dir);
      }

      root.querySelectorAll('[data-nav]').forEach(function (nav) {
        nav.addEventListener('click', function () {
          advance(nav.dataset.nav === 'next' ? 'next' : 'prev');
        });
      });

      if (mainWrap) {
        var sx = null;
        var sy = null;
        var justSwiped = false;
        var lockAxis = null;
        mainWrap.addEventListener(
          'touchstart',
          function (e) {
            if (e.touches.length !== 1) return;
            sx = e.touches[0].clientX;
            sy = e.touches[0].clientY;
            justSwiped = false;
            lockAxis = null;
          },
          { passive: true }
        );
        // Axis lock: once a gesture reads as horizontal, block the page's
        // vertical scroll for its remainder (needs non-passive to preventDefault).
        // Crossing the swipe threshold mid-drag fires the slide immediately —
        // no waiting for release. One advance per gesture.
        mainWrap.addEventListener(
          'touchmove',
          function (e) {
            if (sx === null || e.touches.length !== 1) return;
            var dx = e.touches[0].clientX - sx;
            var dy = e.touches[0].clientY - sy;
            if (!lockAxis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
              lockAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
            }
            if (lockAxis !== 'x') return;
            e.preventDefault();
            if (!justSwiped && Math.abs(dx) >= 40) {
              justSwiped = true;
              advance(dx < 0 ? 'next' : 'prev');
            }
          },
          { passive: false }
        );
        // Release: only a fallback for fast flicks too quick to hit touchmove.
        mainWrap.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var t = e.changedTouches[0];
          var ddx = t.clientX - sx;
          var ddy = t.clientY - sy;
          sx = null;
          sy = null;
          if (justSwiped) return;
          if (Math.abs(ddx) < 40 || Math.abs(ddx) < Math.abs(ddy)) return;
          justSwiped = true;
          advance(ddx < 0 ? 'next' : 'prev');
        });
        // Mobile (arrows hidden): tapping the left/right half of the image
        // advances. The flag keeps a completed swipe's trailing click inert.
        mainWrap.addEventListener('click', function (e) {
          if (justSwiped) {
            justSwiped = false;
            return;
          }
          if (!window.matchMedia('(max-width: 768px)').matches) return;
          var r = mainWrap.getBoundingClientRect();
          advance(e.clientX - r.left < r.width / 2 ? 'prev' : 'next');
        });
      }

      // Shared add-to-cart routine (main ATC, the sticky bar's ATC via the main ATC, one-time purchase link)
      function addToCart(item, btn) {
        var notes = vslNotes();
        if (notes) item.properties = notes;
        btn.dataset.busy = 'true';
        if (ctaErr) ctaErr.hidden = true;
        var reset = function () {
          btn.dataset.busy = 'false';
          btn.disabled = false;
        };
        if (window.cartDrawer && window.cartDrawer.addItem) {
          window.cartDrawer.addItem(item).then(reset, reset);
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] }),
          })
            .then(function (res) {
              if (!res.ok)
                return res.json().then(function (d) {
                  throw new Error((d && d.description) || 'Could not add to cart.');
                });
              return res.json();
            })
            .catch(function (err) {
              if (ctaErr) {
                ctaErr.textContent = err.message;
                ctaErr.hidden = false;
              }
            })
            .finally(reset);
        }
      }

      // Main ATC — selected card's variant id; selling_plan only when the
      // setting is filled (store has no selling plans until Phase 3).
      if (cta) {
        cta.addEventListener('click', function () {
          var sel = selected();
          var id = sel ? sel.getAttribute('data-variant-id') : null;
          if (!id) return;
          var sellingPlanId = sel ? sel.getAttribute('data-selling-plan-id') : '';
          var item = { id: Number(id), quantity: 1 };
          if (sellingPlanId) item.selling_plan = Number(sellingPlanId);
          addToCart(item, cta);
        });
      }

      // One-time purchase link — fixed variant, never a selling plan
      var otp = root.querySelector('[data-pbb2-otp]');
      if (otp) {
        otp.addEventListener('click', function () {
          var id = otp.getAttribute('data-variant-id');
          if (!id) return;
          addToCart({ id: Number(id), quantity: 1 }, otp);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-hero]').forEach(function (root) {
      var cta = root.querySelector('[data-cta]');
      var ctaErr = root.querySelector('[data-cta-error]');
      var tiersWrap = root.querySelector('[data-tiers]');

      function mode() {
        return root.dataset.buyMode || 'subscribe';
      }
      function selected() {
        return root.querySelector('[data-tiers] input:checked');
      }

      // Buy-mode toggle. Subscribe is the default; it stays inert (no selling
      // plan) until a subscriptions app is connected — it only switches the
      // active state for now.
      var toggle = root.querySelector('[data-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function (e) {
          var btn = e.target.closest('button[data-mode]');
          if (!btn) return;
          toggle.querySelectorAll('button').forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          toggle.classList.toggle('is-left', btn.dataset.mode === 'once');
          toggle.classList.toggle('is-right', btn.dataset.mode !== 'once');
          root.dataset.buyMode = btn.dataset.mode;
        });
      }

      // Gallery — thumbnails + nav swap the main image with a slide transition.
      var thumbs = root.querySelector('[data-thumbs]');
      var mainImg = root.querySelector('[data-main] img');
      var mainWrap = root.querySelector('[data-main]');
      var animating = false;
      var DUR = 600;
      var EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
      var cache = Object.create(null);

      function preload(src) {
        if (!src) return Promise.resolve();
        if (cache[src]) return cache[src];
        cache[src] = new Promise(function (res) {
          var i = new Image();
          i.onload = i.onerror = res;
          i.src = src;
        });
        return cache[src];
      }

      // Proactively preload every gallery image when idle, so slides are instant.
      function preloadAll() {
        if (!thumbs) return;
        thumbs.querySelectorAll('button[data-full]').forEach(function (b) {
          preload(b.getAttribute('data-full'));
        });
      }
      if ('requestIdleCallback' in window) {
        requestIdleCallback(preloadAll, { timeout: 2000 });
      } else {
        setTimeout(preloadAll, 1500);
      }

      function slide(newSrc, dir) {
        if (!mainImg || !mainWrap || animating) return;
        animating = true;
        preload(newSrc).then(function () {
          var old = mainImg.cloneNode(true);
          old.removeAttribute('data-main');
          old.style.zIndex = '2';
          mainWrap.insertBefore(old, mainImg.nextSibling);
          var outTo = dir === 'prev' ? '100%' : '-100%';
          var inFrom = dir === 'prev' ? '-100%' : '100%';
          mainImg.src = newSrc;
          mainImg.removeAttribute('srcset');
          var a1 = old.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + outTo + ')' }], {
            duration: DUR,
            easing: EASE,
            fill: 'forwards',
          });
          var a2 = mainImg.animate([{ transform: 'translateX(' + inFrom + ')' }, { transform: 'translateX(0)' }], {
            duration: DUR,
            easing: EASE,
          });
          var done = 0;
          function fin() {
            done++;
            if (done >= 2) {
              old.remove();
              animating = false;
            }
          }
          a1.onfinish = a1.oncancel = fin;
          a2.onfinish = a2.oncancel = fin;
        });
      }

      function activeIndex(btns) {
        var i = btns.findIndex(function (b) {
          return b.classList.contains('is-active');
        });
        return i < 0 ? 0 : i;
      }

      function activateThumb(btn, dir) {
        if (!btn || !thumbs) return;
        // Ignore input while a slide is mid-transition so the active thumb
        // can't run ahead of the main image (fast prev/next double-clicks).
        if (animating) return;
        var btns = Array.prototype.slice.call(thumbs.querySelectorAll('button'));
        var prevIdx = activeIndex(btns);
        var nextIdx = btns.indexOf(btn);
        if (nextIdx === prevIdx) return;
        btns.forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        // Keep the active thumb in view if the strip ever scrolls.
        var li = btn.parentElement;
        if (li && thumbs) {
          var tr = thumbs.getBoundingClientRect();
          var lr = li.getBoundingClientRect();
          if (lr.left < tr.left || lr.right > tr.right) {
            thumbs.scrollTo({
              left: thumbs.scrollLeft + (lr.left - tr.left) - (tr.width - lr.width) / 2,
              behavior: 'smooth',
            });
          }
        }
        var img = btn.querySelector('img');
        var nextSrc = btn.getAttribute('data-full') || (img && img.src);
        if (!nextSrc) return;
        slide(nextSrc, dir || (nextIdx > prevIdx ? 'next' : 'prev'));
      }

      if (thumbs) {
        thumbs.addEventListener('click', function (e) {
          var btn = e.target.closest('button[data-thumb]');
          if (btn) activateThumb(btn);
        });
      }

      function advance(dir) {
        if (!thumbs) return;
        var btns = Array.prototype.slice.call(thumbs.querySelectorAll('button'));
        if (!btns.length) return;
        var idx = activeIndex(btns);
        var step = dir === 'next' ? 1 : -1;
        activateThumb(btns[(idx + step + btns.length) % btns.length], dir);
      }

      root.querySelectorAll('[data-nav]').forEach(function (nav) {
        nav.addEventListener('click', function () {
          advance(nav.dataset.nav === 'next' ? 'next' : 'prev');
        });
      });

      if (mainWrap) {
        var sx = null;
        var sy = null;
        mainWrap.addEventListener(
          'touchstart',
          function (e) {
            if (e.touches.length !== 1) return;
            sx = e.touches[0].clientX;
            sy = e.touches[0].clientY;
          },
          { passive: true }
        );
        mainWrap.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var t = e.changedTouches[0];
          var ddx = t.clientX - sx;
          var ddy = t.clientY - sy;
          sx = null;
          sy = null;
          if (Math.abs(ddx) < 40 || Math.abs(ddx) < Math.abs(ddy)) return;
          advance(ddx < 0 ? 'next' : 'prev');
        });
      }

      // Add to cart — single source: selected tier's variant id (+ selling plan when present)
      function syncCta() {
        if (!cta) return;
        if (ctaErr) ctaErr.hidden = true;
        cta.disabled = false;
      }
      if (tiersWrap) {
        tiersWrap.addEventListener('change', function (e) {
          if (e.target && e.target.name === 'ph-tier') syncCta();
        });
      }
      if (cta) {
        cta.addEventListener('click', function () {
          var sel = selected();
          var id = sel ? sel.getAttribute('data-variant-id') : null;
          if (!id) return;
          var sellingPlanId = sel ? sel.getAttribute('data-selling-plan-id') : '';
          var item = { id: Number(id), quantity: 1 };
          if (mode() === 'subscribe' && sellingPlanId) item.selling_plan = Number(sellingPlanId);
          cta.dataset.busy = 'true';
          if (ctaErr) ctaErr.hidden = true;
          var reset = function () {
            cta.dataset.busy = 'false';
            cta.disabled = false;
          };
          if (window.cartDrawer && window.cartDrawer.addItem) {
            window.cartDrawer.addItem(item).then(reset, reset);
          } else {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [item] }),
            })
              .then(function (res) {
                if (!res.ok)
                  return res.json().then(function (d) {
                    throw new Error((d && d.description) || 'Could not add to cart.');
                  });
                return res.json();
              })
              .catch(function (err) {
                if (ctaErr) {
                  ctaErr.textContent = err.message;
                  ctaErr.hidden = false;
                }
              })
              .finally(reset);
          }
        });
      }

      syncCta();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-teaser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function copyImage(from, to) {
      if (!from || !to) return;
      var srcset = from.getAttribute('srcset');
      var sizes = from.getAttribute('sizes');
      if (srcset) to.setAttribute('srcset', srcset);
      else to.removeAttribute('srcset');
      if (sizes) to.setAttribute('sizes', sizes);
      else to.removeAttribute('sizes');
      var src = from.getAttribute('src');
      if (src) to.setAttribute('src', src);
      if (from.alt) to.alt = from.alt;
    }

    document.querySelectorAll('[data-pt-gallery]').forEach(function (wrap) {
      var mainImg = wrap.querySelector('.product-teaser__main img');
      var thumbs = wrap.querySelectorAll('.product-teaser__thumb');
      if (!mainImg || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          copyImage(thumb.querySelector('img'), mainImg);
          thumbs.forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proven-stats-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const DURATION = 1400;
    const reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

    function animateCounter(el, target) {
      let start = null;
      let lastValue = -1;
      function step(ts) {
        if (start === null) start = ts;
        const elapsed = ts - start;
        const progress = Math.min(elapsed / DURATION, 1);
        const value = Math.round(target * easeOutCubic(progress));
        if (value !== lastValue) {
          el.textContent = value + '%';
          lastValue = value;
        }
        if (progress < 1) requestAnimationFrame(step);
        else if (lastValue !== target) el.textContent = target + '%';
      }
      requestAnimationFrame(step);
    }

    function trigger(section) {
      if (section.classList.contains('is-animated')) return;
      section.classList.add('is-animated');
      section.setAttribute('data-pt-animated', '');

      const arcs = section.querySelectorAll('[data-pt-bar]');
      const counters = section.querySelectorAll('[data-pt-counter]');

      if (reduce || section.hasAttribute('data-animations-disabled')) {
        arcs.forEach(function (arc) { arc.classList.add('is-animated'); });
        counters.forEach(function (el) {
          const t = parseInt(el.getAttribute('data-target'), 10) || 0;
          el.textContent = t + '%';
        });
        return;
      }

      arcs.forEach(function (arc) {
        arc.classList.add('is-animating');
        // eslint-disable-next-line no-unused-expressions
        arc.getBoundingClientRect();
        arc.classList.add('is-animated');
        const cleanup = function (e) {
          if (e.propertyName !== 'stroke-dashoffset') return;
          arc.classList.remove('is-animating');
          arc.removeEventListener('transitionend', cleanup);
        };
        arc.addEventListener('transitionend', cleanup);
      });

      counters.forEach(function (el) {
        const t = parseInt(el.getAttribute('data-target'), 10) || 0;
        el.textContent = '0%';
        animateCounter(el, t);
      });
    }

    function init(section) {
      if (!('IntersectionObserver' in window)) { trigger(section); return; }
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            trigger(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      io.observe(section);
    }

    document.querySelectorAll('[data-proven-stats]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc-v2"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-sav2-bar]');
    if (!bar) return;
    document.body.classList.add('sav2-present'); // fallback for the :has() body padding

    var barLabel = bar.querySelector('[data-sav2-label]');
    var barServing = bar.querySelector('[data-sav2-serving]');
    var barPrice = bar.querySelector('[data-sav2-price]');

    function radios() {
      return document.querySelectorAll('input[name="pbb2-plan"]');
    }
    function checkedRadio() {
      return document.querySelector('input[name="pbb2-plan"]:checked');
    }

    // Card selection drives the bar — the radios are the single source of
    // truth, and their data-bar-* attrs carry the same site-wide settings.
    function syncBar() {
      var sel = checkedRadio();
      if (!sel) return;
      if (barLabel) barLabel.textContent = sel.getAttribute('data-bar-label') || '';
      if (barServing) barServing.textContent = sel.getAttribute('data-bar-serving') || '';
      if (barPrice) barPrice.textContent = sel.getAttribute('data-bar-price') || '';
    }
    radios().forEach(function (input) {
      input.addEventListener('change', syncBar);
    });
    syncBar(); // browsers may restore form state on reload

    // Dropdown open/close — menu opens upward
    var select = bar.querySelector('[data-sav2-select]');
    var toggle = select.querySelector('.sav2__toggle');
    function setOpen(open) {
      select.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    toggle.addEventListener('click', function () {
      setOpen(!select.classList.contains('is-open'));
    });
    document.addEventListener('click', function (e) {
      if (!select.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    // Picking an option drives the same radios the cards use
    select.querySelectorAll('[data-sav2-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var value = opt.getAttribute('data-sav2-option');
        var input = document.querySelector('input[name="pbb2-plan"][value="' + value + '"]');
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        setOpen(false);
      });
    });

    // Bar ATC = real add-to-cart: identical action to the main button
    var atc = bar.querySelector('[data-sav2-atc]');
    if (atc) {
      atc.addEventListener('click', function () {
        var mainCta = document.querySelector('[data-pbb2-cta]');
        if (mainCta) mainCta.click();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
